import React, {useState} from 'react'
import {Button, Form, Input, Modal} from "antd";
import {createRelevantPerson} from "../../services/serviceRelevantPerson";
import {useParams} from "@reach/router";
import {enterLoadingState, exitLoadingState} from "../../utils/helpers/commonFunctions";

const RelevantCreate = ({show, modalCloser, updater}) => {

    const [form] = Form.useForm()
    const {customerId} = useParams()
    const [loadings, setLoadings] = useState([])

    const handleSubmit = () => {
        enterLoadingState(setLoadings)
        const {
            name,
            surname,
            title,
            internal,
            phone
        } = form.getFieldsValue()
        let requestObj = {
            customer: {
                id: customerId
            },
            name: name,
            surname: surname,
            phone: phone,
            internalPhoneCode: internal,
            title: title
        }

        createRelevantPerson(requestObj)
            .then(() => {
                exitLoadingState(setLoadings)
                modalCloser()
                updater()
            })
            .then(() => exitLoadingState(setLoadings))
    }

    return(
        <React.Fragment>
            <Modal
                open={show}
                title={'Temsilci Ekle'}
                onCancel={modalCloser}
                footer={[
                    <Button
                        key={'SubmitButton'}
                        type={'primary'}
                        onClick={() => form.submit()}
                        loading={loadings[0]}
                    >
                        Kaydet
                    </Button>,
                    <Button
                        key={'CancelButton'}
                        onClick={modalCloser}
                    >
                        Kapat
                    </Button>
                ]}
            >
                <Form
                    form={form}
                    onFinish={handleSubmit}
                    labelAlign={'left'}
                    labelCol={{span: 8}}
                    wrapperCol={{span: 16}}
                >
                    <Form.Item
                        name={'name'}
                        label={'İlgili Adı'}
                        rules={[
                            {required: true, message: 'Bu Alan Boş Bırakılamaz'}
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        name={'surname'}
                        label={'İlgili Soyadı'}
                        rules={[
                            {required: true, message: 'Bu Alan Boş Bırakılamaz'}
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        name={'title'}
                        label={'İlgili Ünvan'}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        name={'phone'}
                        label={'İlgili Telefonu'}
                        rules={[
                            {required:true, message: 'Bu Alan Boş Bırakılamaz'},
                            {pattern: /^\d*$/, message: 'Telefon Alanı Numaralardan Oluşmalıdır'}
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        name={'internal'}
                        label={'Dahili'}
                    >
                        <Input />
                    </Form.Item>
                </Form>
            </Modal>
        </React.Fragment>
    )
}
export default RelevantCreate